import { Calculator, SlidersHorizontal } from 'lucide-react';

export type SolutionsView = 'explore' | 'practice';

const VIEWS: { view: SolutionsView; label: string; hint: string; Icon: typeof Calculator }[] = [
  { view: 'explore', label: 'Explore', hint: 'your own numbers, working always shown', Icon: SlidersHorizontal },
  { view: 'practice', label: 'Practice', hint: 'answer first, then check', Icon: Calculator },
];

/** Explore (learner inputs, worked calculation) or Practice (fixed problem, answer first). */
export function ViewSwitch({ view, onChange }: { view: SolutionsView; onChange: (next: SolutionsView) => void }) {
  return (
    <div className="mb-4 flex flex-wrap gap-2" role="group" aria-label="Choose Explore or Practice">
      {VIEWS.map(({ view: option, label, hint, Icon }) => (
        <button
          key={option}
          type="button"
          aria-pressed={view === option}
          onClick={() => onChange(option)}
          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-extrabold transition-colors ${
            view === option ? 'border-ink bg-ink text-white' : 'border-hairline bg-canvas-pure text-ink-soft hover:border-brand-sky/50'
          }`}
        >
          <Icon className="h-4 w-4" aria-hidden="true" />
          {label}
          <span className={`hidden text-xs font-semibold sm:inline ${view === option ? 'text-white/80' : 'text-slate2'}`}>· {hint}</span>
        </button>
      ))}
    </div>
  );
}
